import { useEffect } from 'react';
export function useIntervalEffect(delay, callback, deps) {
    useEffect(() => {
        const intervalId = setInterval(callback, delay);
        return () => clearInterval(intervalId);
    }, [delay, ...deps]);
}
